(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["af-collection-vitrine"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('af-collection-vitrine')) {
    customElements.define(
      'af-collection-vitrine',
      class AfCollectionVitrine extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.lastKey = this.keyOf(window.location.href);
          this.priceTimer = null;
          this.controller = null;

          this.handleClick = this.handleClick.bind(this);
          this.handleChange = this.handleChange.bind(this);
          this.handleInput = this.handleInput.bind(this);
          this.handleSubmit = this.handleSubmit.bind(this);
          this.handlePopState = this.handlePopState.bind(this);

          this.addEventListener('click', this.handleClick);
          this.addEventListener('change', this.handleChange);
          this.addEventListener('input', this.handleInput);
          this.addEventListener('submit', this.handleSubmit);
          window.addEventListener('popstate', this.handlePopState);

          this.querySelectorAll('dialog').forEach((dialog) => {
            dialog.addEventListener('close', () => this.unlockScroll());
          });

          this.initDescription();
        }

        disconnectedCallback() {
          window.removeEventListener('popstate', this.handlePopState);
          document.documentElement.classList.remove('afc-lock');
        }

        keyOf(href) {
          const url = new URL(href, window.location.origin);
          url.searchParams.delete('page');
          url.searchParams.delete('section_id');
          return url.pathname + url.search;
        }

        unlockScroll() {
          if (!this.querySelector('.afc-sheet[open]')) {
            document.documentElement.classList.remove('afc-lock');
          }
        }

        handleClick(event) {
          const target = event.target;

          // Clic sur le voile : la cible est le dialog lui-même
          if (target instanceof HTMLDialogElement) {
            target.close();
            return;
          }

          const opener = target.closest('[data-afc-open]');
          if (opener) {
            const dialog = document.getElementById(opener.dataset.afcOpen);
            if (dialog && !dialog.open) {
              dialog.showModal();
              document.documentElement.classList.add('afc-lock');
            }
            return;
          }

          if (target.closest('[data-afc-close]')) {
            target.closest('dialog')?.close();
            return;
          }

          const more = target.closest('a[data-afc-more]');
          if (more) {
            event.preventDefault();
            this.loadMore(more);
            return;
          }

          const link = target.closest('a[data-afc-link]');
          if (link) {
            event.preventDefault();
            const inDialog = Boolean(link.closest('dialog'));
            this.update(link.href, { scroll: !inDialog });
            return;
          }

          const toggle = target.closest('[data-afc-desc-toggle]');
          if (toggle) this.toggleDescription(toggle);
        }

        handleChange(event) {
          const target = event.target;

          if (target.type === 'radio' && target.name === 'sort_by') {
            const url = new URL(window.location.href);
            url.searchParams.set('sort_by', target.value);
            target.closest('dialog')?.close();
            this.update(url.href, { scroll: true });
            return;
          }

          const form = target.closest('form[data-afc-filter-form]');
          if (form) {
            clearTimeout(this.priceTimer);
            this.priceTimer = null;
            this.applyFilters(form);
          }
        }

        handleInput(event) {
          const target = event.target;
          if (target.type !== 'number') return;
          const form = target.closest('form[data-afc-filter-form]');
          if (!form) return;
          clearTimeout(this.priceTimer);
          this.priceTimer = setTimeout(() => {
            this.priceTimer = null;
            this.applyFilters(form);
          }, 700);
        }

        handleSubmit(event) {
          const form = event.target.closest('form[data-afc-filter-form]');
          if (!form) return;
          event.preventDefault();
          if (this.priceTimer) {
            clearTimeout(this.priceTimer);
            this.priceTimer = null;
            this.applyFilters(form);
          }
          form.closest('dialog')?.close();
          this.scrollToResults();
        }

        handlePopState() {
          this.lastKey = null;
          this.update(window.location.href, { push: false });
        }

        applyFilters(form) {
          const params = new URLSearchParams();
          new FormData(form).forEach((value, key) => {
            if (key !== 'sort_by' && String(value).trim() !== '') params.append(key, value);
          });
          const sort = new URL(window.location.href).searchParams.get('sort_by');
          if (sort) params.set('sort_by', sort);
          const query = params.toString();
          this.update(window.location.pathname + (query ? `?${query}` : ''));
        }

        async update(href, { scroll = false, push = true } = {}) {
          const key = this.keyOf(href);
          if (key === this.lastKey) {
            if (scroll) this.scrollToResults();
            return;
          }
          this.lastKey = key;

          this.controller?.abort();
          const controller = new AbortController();
          this.controller = controller;

          const fetchUrl = new URL(key, window.location.origin);
          fetchUrl.searchParams.set('section_id', this.sectionId);
          this.setAttribute('aria-busy', 'true');

          try {
            const response = await fetch(fetchUrl, { signal: controller.signal });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const fresh = doc.querySelector('af-collection-vitrine');
            if (!fresh) throw new Error('Section introuvable');

            const focusedId = document.activeElement?.id;
            this.querySelectorAll('[data-afc-part]').forEach((part) => {
              const next = fresh.querySelector(`[data-afc-part="${part.dataset.afcPart}"]`);
              if (next) part.replaceWith(next);
            });
            if (focusedId) document.getElementById(focusedId)?.focus({ preventScroll: true });

            if (push) window.history.pushState({ afc: true }, '', key);
            if (scroll) this.scrollToResults();
          } catch (error) {
            if (error.name !== 'AbortError') window.location.assign(key);
          } finally {
            if (this.controller === controller) this.removeAttribute('aria-busy');
          }
        }

        async loadMore(link) {
          if (link.getAttribute('aria-busy') === 'true') return;
          link.setAttribute('aria-busy', 'true');

          const fetchUrl = new URL(link.href, window.location.origin);
          fetchUrl.searchParams.set('section_id', this.sectionId);

          try {
            const response = await fetch(fetchUrl);
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const fresh = doc.querySelector('af-collection-vitrine');
            const grid = this.querySelector('[data-afc-grid]');
            const items = fresh ? Array.from(fresh.querySelectorAll('[data-afc-grid] > li')) : [];
            if (!grid || !items.length) throw new Error('Aucun produit');

            grid.append(...items);

            const pager = this.querySelector('[data-afc-pager]');
            const nextPager = fresh.querySelector('[data-afc-pager]');
            if (pager && nextPager) pager.replaceWith(nextPager);
            else pager?.remove();

            items[0].querySelector('a')?.focus({ preventScroll: true });
          } catch (error) {
            window.location.assign(link.href);
          }
        }

        scrollToResults() {
          const anchor = this.querySelector('[data-afc-anchor]');
          if (!anchor) return;
          const header = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
          const top = anchor.getBoundingClientRect().top;
          if (top < header || top > window.innerHeight * 0.6) {
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            anchor.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          }
        }

        initDescription() {
          this.querySelectorAll('[data-afc-desc]').forEach((box) => {
            const body = box.querySelector('[data-afc-desc-body]');
            const toggle = box.querySelector('[data-afc-desc-toggle]');
            const visible = parseInt(box.dataset.visible, 10) || 2;
            if (!body || !toggle) return;
            const extra = Array.from(body.children).slice(visible);
            if (!extra.some((el) => el.textContent.trim() !== '')) return;
            extra.forEach((el) => el.classList.add('afc-desc__more'));
            box.classList.add('is-collapsed');
            toggle.hidden = false;
          });
        }

        toggleDescription(toggle) {
          const box = toggle.closest('[data-afc-desc]');
          if (!box) return;
          const collapsed = box.classList.toggle('is-collapsed');
          toggle.setAttribute('aria-expanded', String(!collapsed));
          toggle.querySelector('[data-more]').hidden = !collapsed;
          toggle.querySelector('[data-less]').hidden = collapsed;
          if (collapsed) box.scrollIntoView({ block: 'nearest' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offre-speciale"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPcOffre() {
      document.querySelectorAll('.pc-offre').forEach(function (root) {
        if (root.dataset.pcFaqBound) return;
        root.dataset.pcFaqBound = '1';
        root.querySelectorAll('.pc-faq details').forEach(function (item) {
          item.addEventListener('toggle', function () {
            if (!item.open) return;
            root.querySelectorAll('.pc-faq details[open]').forEach(function (other) {
              if (other !== item) other.removeAttribute('open');
            });
          });
        });
      });
    }
    initPcOffre();
    document.addEventListener('shopify:section:load', initPcOffre);
  })();

  } catch(e) { console.error(e); }
})();
})();
